const REFERRERS_URLS = ['https://www.orange.pl/zaloguj.phtml', 'https://www.orange.pl/twojekonto/'];

const SIGN_IN_URLS = [
    'https://esklep.online.corpnet.pl/konsola-konsultanta',
    'https://esklep.online.corpnet.pl/omnibook',
    'https://esklep.online.orange.pl/omnibook',
    'https://www.orange.pl/moj-orange'
];

export const isUserMOLoggedIn = (referrer, locationHref) => {
    let referrerMatch = false;
    let locationMatch = false;

    REFERRERS_URLS.forEach((r) => {
        if (!referrerMatch && (referrer.match(new RegExp(`^${r}`, 'g')) || referrer.match(r))) {
            referrerMatch = true;
        }
    });

    if (!referrerMatch) {
        return false;
    }

    SIGN_IN_URLS.forEach((s) => {
        if (
            !locationMatch &&
            (locationHref.match(new RegExp(`^${s}`, 'g')) || locationHref.match(s))
        ) {
            locationMatch = true;
        }
    });

    return locationMatch;
};
